import { PhoneNumberTest } from "utils/PhoneNumber";
import { trimWhiteSpace } from "utils/String";

export interface IInputValidationProps {
  value: string;
  name?: string;
  minLength?: number;
  required?: boolean;
  compare?: {
    name: string;
    value: string;
  };
}

export const validators: any = {
  email: (
    value: string,
    name: string,
    minLength?: number,
    required?: boolean,
    compare?: { name: string; value: string; }
  ) => {
    if (
      !/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value
      ) &&
      required
    )
      return "Digite um e-mail válido";
    if (compare && compare.value && compare.value !== value)
      return `${name || "E-mail"} precisa ser igual ${compare.name}`;

    return false;
  },
  password: (
    value: string,
    name: string,
    minLength?: number,
    required?: boolean,
    compare?: { name: string; value: string; }
  ): any => {
    if (value?.length === 0 && required === true) return `${name || "Senha"} é requerido`;
    if (minLength && value?.length < minLength)
      return `${name || "Senha"} deve conter no mínimo ${minLength} caracteres`;
    if (compare && compare.value && compare.value !== value)
      return `${name || "Senha"} precisa ser igual ${compare.name}`;

    return false;
  },
  text: (
    value: string,
    name: string,
    minLength?: number,
    required?: boolean,
    compare?: { name: string; value: string; },
    customValidate?: boolean
  ): any => {
    if (!value && required === true) return `${name || "Campo"} é requerido`;
    if (minLength && value?.length < minLength)
      return `${name || "Campo"} deve conter no mínimo ${minLength} caracteres`;
    if (compare && compare.value && compare.value !== value)
      return `${name || "Esse campo"} precisa ser igual ${compare.name}`;
    if (customValidate && value && parseFloat(value.replace(/\D/g, '')) === 0)
      return `${name || "Esse campo"} precisa ser maior que R$ 0,00`;

    return false;
  },
  telphone: (
    value: string,
    name: string,
    minLength?: number,
    required?: boolean,
    compare?: { name: string; value: string; }
  ): any => {
    if (value?.length === 0 && required === true) return `${name || "Telefone"} é requerido`;
    if (!PhoneNumberTest(value) && required === true) return `Digite um telefone válido`;
    if (compare && compare.value && compare.value !== value)
      return `${name || "Telefone"} precisa ser igual ${compare.name}`;

    return false;
  },
  date: (
    value: string,
    name: string,
    minLength?: number,
    required?: boolean
  ): any => {
    if (value?.length === 0 && required === true) return `${name || "Data"} é requerida`;
    return false;
  },
  select: (value: string, name: string, required?: boolean): any => {
    if (value?.length === 0 && required === true) return `${name || "Campo"} é requerido`;

    return false;
  },
  textarea: (value: string, name: string, minLength?: number, required?: boolean): any => {
    if (value?.length === 0 && required === true) return `${name || "Campo"} é requerido`;
    if (minLength && value?.length < minLength)
      return `${name || "Campo"} deve conter no mínimo ${minLength} caracteres`;

    return false;
  },
  textAreaOutRangeLength: (value: string, name: string, minLength?: number, required?: boolean, maxLength?: number): any => {
    const valueFormat = trimWhiteSpace(value);

    if (valueFormat?.length === 0 && required === true) return `${name || "Campo"} é requerido`;
    if (minLength && valueFormat?.length < minLength)
      return `${name || "Campo"} deve conter no mínimo ${minLength} caracteres`;

    if (maxLength && valueFormat?.length > maxLength)
      return `${name || "Campo"} deve conter no máximo ${maxLength} caracteres`;

    return false;
  },

  radio: (name: string, required?: boolean): any => {
    if (document.querySelectorAll(`input[name='${name}']:checked`).length === 0 && required === true)
      return `${name || "Campo"} é requerido`;
    return false;
  },

  file: (value: any, name: string, minLength?: number, required?: boolean): any => {
    if (required) {
      if (!value) {
        return `${name || "Arquivo"} é requerido`;
      }

      if (typeof value === "string" && value.trim().length === 0) {
        return `${name || "Arquivo"} é requerido`;
      }

      if (typeof value === "object" && "size" in value && value.size === 0) {
        return `${name || "Arquivo"} é requerido`;
      }
    }
    return false;
  }
};
